export default "__VITE_ASSET__DGyemt2m__"